module.exports = __webpack_public_path__ + "static/media/logo.949824dd.png";